import { fetchUsersThunk, fetchUserByIdThunk } from '../features/users/usersSlice';
import { setLastVisitedRoute } from '../features/ui/uiSlice';
import type { AppDispatch } from '../store';

export const dispatchRouteData = (pathname: string, dispatch: AppDispatch): void => {
  dispatch(setLastVisitedRoute(pathname));

  const userDetailMatch = pathname.match(/^\/user\/(.+)$/);
  if (userDetailMatch) {
    dispatch(fetchUserByIdThunk(userDetailMatch[1]));
    return;
  }

  switch (pathname) {
    case '/user':
      dispatch(fetchUsersThunk());
      break;
    default:
      break;
  }
};
